import { InputBase, Typography, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useEffect } from 'react';
import { useState } from 'react';

const INVALID_INPUT_BORDER_COLOR = '#CC3333';

export default function FlatInput({ label, Tooltip, isRequired, value, placeholder, onChange, notValid, isReadOnly, displayBtn = false, btnLabel = '', onBtnClicked, inputType = 'text' }) {
    const useStyles = makeStyles((theme) => ({
        InputBase: {
            width: '100%',
            height: '40px',
            display: 'flex',
            justifyContent: 'space-between',
            border: '1px solid #CCCCCC',
            padding: '0 10px',
            fontFamily: 'Hind',
            color: '#28282E',
            borderRadius: '4px',
            '&:active, &:focus, &:hover': {
                color: '#28282E',
                boxShadow: 'unset',
                borderColor: '#2057AD'
            },
            '&>input': {
                '&::placeholder': {
                    fontFamily: 'Hind !important',
                    fontSize: '16px !important',
                    fontWeight: '400 !important',
                    lineHeight: '23.59px !important',
                    fontStyle: 'italic !important',
                    color: '#B1B1B1 !important'
                }
            }
        },
        header: {
            color: '#28282E',
            fontFamily: 'Hind',
            fontSize: '1rem',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '20px',
            paddingBottom: '5px',
        },
        Required: {
            color: '#F1913B',
        },
        InnerInput: {
            fontSize: '16px',
            fontFamily: 'Hind',
            fontWeight: '400',
            fontStyle: 'normal',
            lineHeight: '20px',
            padding: 0,
            paddingTop: '3px',
            height: 'auto',
        },
        btnContainer: {
            display: 'flex  '
        }
    }));

    const classes = useStyles();
    const [_value, setValue] = useState(value);

    useEffect(() => {
        setValue(value);
    }, [value]);

    function handleOnChange(event) {
        const { value } = event.target;
        setValue(value);
        if (onChange) {
            onChange(value);
        }
    }

    const hasLocalValue = _value !== undefined && _value !== null;
    const hasPropValue = value !== undefined && value !== null;
    const inputValue = hasLocalValue ? _value : (hasPropValue ? value : '');

    return (
        <div style={{ width: '100%', paddingTop: '10px' }}>
            {
                !!label && (
                    <Typography className={classes.header}>
                        {label}
                        {isRequired && (<span className={classes.Required}>{' '}* Required</span>)}
                        {' '}
                        {Tooltip && (<Tooltip />)}
                    </Typography>
                )
            }
            {
                isReadOnly && (
                    <p>{_value ? _value : '-'}</p>
                )
            }
            {
                !isReadOnly && (
                    <div style={{ display: 'flex' }}>
                        <InputBase
                            id='baseSearchBox'
                            autoComplete='off'
                            type={inputType}
                            placeholder={placeholder}
                            onChange={handleOnChange}
                            value={inputValue}
                            classes={{
                                root: classes.InputBase
                            }}
                            style={{ borderColor: `${notValid ? INVALID_INPUT_BORDER_COLOR : ''}` }}
                            inputProps={{
                                className: classes.InnerInput,
                            }}
                        />
                        {
                            displayBtn && (
                                <Button variant='outlined' disableRipple={true} aria-controls='customized-menu' onClick={onBtnClicked}>{btnLabel}</Button>
                            )
                        }
                    </div>
                )
            }
        </div>

    );
}